module.exports = __webpack_public_path__ + "img/1548211862.1e27c30f.jpg";